<app-garmin-login [redirect]="true"></app-garmin-login>
